import { render, staticRenderFns } from "./InfoCupo.vue?vue&type=template&id=70007b4c"
import script from "./InfoCupo.vue?vue&type=script&lang=js"
export * from "./InfoCupo.vue?vue&type=script&lang=js"
import style0 from "./InfoCupo.vue?vue&type=style&index=0&id=70007b4c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports